import React from 'react';
import { createRoot } from 'react-dom/client';
import vkBridge, { parseURLSearchParamsForGetLaunchParams } from '@vkontakte/vk-bridge';
import { useAdaptivity, useInsets } from '@vkontakte/vk-bridge-react';
import { AdaptivityProvider, AppRoot, ConfigProvider } from '@vkontakte/vkui';
import { RouterProvider } from '@vkontakte/vk-mini-apps-router';
import App from './App';
import { router } from './routing/routing';
import './styles/index.css';

vkBridge.send('VKWebAppInit');

function Root() {
  const insets = useInsets() || undefined;
  const adaptivity = useAdaptivity();
  const { vk_platform } = parseURLSearchParamsForGetLaunchParams(window.location.search);

  return (
    <ConfigProvider appearance="light" platform={vk_platform === 'desktop_web' ? 'android' : undefined} isWebView={vkBridge.isWebView()}>
      <AdaptivityProvider {...adaptivity}>
        <AppRoot mode="full" safeAreaInsets={insets}>
          <RouterProvider router={router}>
            <App />
          </RouterProvider>
        </AppRoot>
      </AdaptivityProvider>
    </ConfigProvider>
  );
}

createRoot(document.getElementById('root')).render(<Root />);
